// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticoloTemplate_title__BDrRp","imageBox":"ArticoloTemplate_imageBox__udxbK","date":"ArticoloTemplate_date__sQnqQ","actions":"ArticoloTemplate_actions__Fnuh2"};